import React from 'react';

import { Box, ColumnsV2, ColumnsV2Props } from '@withjoy/joykit';
import { animationTransition } from '@shared/utils/animationTransition';
import { isInIframe } from '@shared/utils/isInIframe';
import { StyledBoxBrannan } from './Frames.styles';

export const BrannanFrameMaxWidth = 1024;

const FrameOuter: React.FC<
  HtmlProps<HTMLElement> & { applicatorProp: object; loading: boolean; customBackgroundColor?: string; isCustomPage?: boolean; customTextColor?: string }
> = ({ applicatorProp, children, loading, customBackgroundColor, customTextColor, isCustomPage, ...restProps }) => {
  const isPreviewing = isInIframe();
  return (
    <StyledBoxBrannan
      loading={loading}
      {...applicatorProp}
      transition={animationTransition('background', 'background-color')}
      data-testid={'outer-frame'}
      {...restProps}
      position={'relative'}
      isPreviewing={isPreviewing}
      customBackgroundColor={customBackgroundColor}
      customTextColor={customTextColor}
    >
      {/* This overflow clip is necessary to prevent the center part of the page from scrolling */}
      <Box overflow={'clip'}>{children}</Box>
    </StyledBoxBrannan>
  );
};

const FrameInner: React.FC<HtmlProps<HTMLElement> & ColumnsV2Props> = ({ children, ...restProps }) => {
  return (
    <ColumnsV2
      fluid={true}
      maxWidth={[null, null, BrannanFrameMaxWidth]}
      {...restProps}
    >
      <ColumnsV2.Column data-testid={'inner-frame'}>{children}</ColumnsV2.Column>
    </ColumnsV2>
  );
};

export { FrameOuter, FrameInner };
